export default {
  name: "KilaKilaSideBar"
};